// JavaScript
import React, { useEffect, useState } from 'react';
import {
  Button,
  Dialog,
  DialogContent,
  DialogActions,
  DialogContentText,
  IconButton,
  FormControl,
  DialogTitle,
  Box
} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import { useSnackbar } from "notistack";
import sendRequest from "../services/sendRequest";
import './export.css';
import MoonLoader from "react-spinners/MoonLoader";
import * as XLSX from 'xlsx';

const UploadAssetIds = ({ open, close, selectedRows }) => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [fullWidth] = useState(true);
  const [maxWidth] = useState('sm');
  const [color] = useState("#000000");

  const override = {
    display: "block",
    margin: "0 auto",
    borderColor: "red",
  };

  if (!open) return null;

  // handleAllTypesOfMessages
  const handleAllTypesOfMessages = (message, type) => {
    const action = (key) => (
      <IconButton
        aria-label="close"
        color="inherit"
        onClick={() => closeSnackbar(key)}
      >
        <CloseIcon />
      </IconButton>
    );

    enqueueSnackbar(message, {
      variant: type,
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'left',
      },
      persist: true, // keeps the snackbar visible until manually closed
      action
    });
  };

  // handleAllTypesOfMessages
  const handleAllTypesOfMessagesAutomaticClose = (message, type) => {
    const action = (key) => (
      <IconButton
        aria-label="close"
        color="inherit"
        onClick={() => closeSnackbar(key)}
      >
        <CloseIcon />
      </IconButton>
    );

    enqueueSnackbar(message, {
      variant: type,
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'left',
      },
      // persist: true, // keeps the snackbar visible until manually closed
      autoHideDuration: 20000,
      action
    });
  };

  const handleFileUpload = e => {
    let showWarning = true;
    let isValidColumns = true;
    let channelNotMatch = true;
    let invalidRowIndex = 0;
    setLoading(true);

    const file = e.target.files[0];
    const reader = new FileReader();

    const chunkArray = (arr, size) => {
      const chunks = [];
      for (let i = 0; i < arr.length; i += size) {
        chunks.push(arr.slice(i, i + size));
      }
      return chunks;
    };

    reader.onload = async (evt) => {
      try {
        const bstr = evt.target.result;
        const wb = XLSX.read(bstr, { type: 'binary' });

        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];

        const Papa = require('papaparse');
        const fileData = XLSX.utils.sheet_to_csv(ws, { header: 1 });

        const parsedData = Papa.parse(fileData, {
          header: false, // Set to true if the first row contains headers
        });

        if (parsedData.data.length > 200) {
          handleAllTypesOfMessages(
            'The uploaded file contains more than 200 items. Please upload a file with 200 items or less.',
            'warning'
          );
          setLoading(false);
          return;
        }

        let columns = [];
        const parsedItems = [];

        parsedData.data.forEach((row, rowIndex) => {
          if (row.length !== 4) {
            isValidColumns = false;
            showWarning = false;
            invalidRowIndex = rowIndex;
            return;
          }

          if (row[2] != selectedRows[0].channel_id) {
            channelNotMatch = false;
            showWarning = false;
            invalidRowIndex = rowIndex;
            return;
          }

          row.forEach((cell, colIndex) => {
            if (!columns[colIndex]) {
              columns[colIndex] = [];
            }
            columns[colIndex][rowIndex] = cell;
          });
          let content_owner_id = '';
          const newObject = {
            asset_id: row[0],
            custom_id: row[1],
            channel_id: content_owner_id,
            correct_custome_id: selectedRows && selectedRows[0] ? selectedRows[0].custom_id : '',
            origin_channel_id: row[2],
          };
          parsedItems.push(newObject);
        });

        if (showWarning) {
          const getPayawayContentOwnerIdCmsResponse = await sendRequest({
              requestType: "get",
              endpoint: `customIdsPerChannel/getPayawayContentOwnerIdCms/`,
            });

          if(getPayawayContentOwnerIdCmsResponse && getPayawayContentOwnerIdCmsResponse.data){
            if(getPayawayContentOwnerIdCmsResponse.data.result && getPayawayContentOwnerIdCmsResponse.data.result.length > 0){
              let content_owner_id = '';
              for (let i = 0; i < getPayawayContentOwnerIdCmsResponse.data.result.length; i++) {
                if (getPayawayContentOwnerIdCmsResponse.data.result[i].cms == selectedRows[0].cms){
                  content_owner_id = getPayawayContentOwnerIdCmsResponse.data.result[i].contecontent_owner_id;
                  break;
                }
              }
              for (let i = 0; i < parsedItems.length; i++) {
                  parsedItems[i].channel_id = content_owner_id
              }
            } else {
              handleAllTypesOfMessages(
              'Please check the CMS and ContentOwnerIdCms in Payaway table .',
              'warning'
            );
            }            
          }

          const batches = chunkArray(parsedItems, 50);
          let anyBatchFailed = false;
          let totalCompleted = 0 ;
          for (let i = 0; i < batches.length; i++) {            
            const batch = batches[i];
            const response = await sendRequest({
              requestType: 'post',
              endpoint: `customIdsPerChannel/update_yt_bulk_and_save_failed_assets_details/`,
              requestData: {
                items: batch,
                email: localStorage.getItem('username'),
                correct_custome_id: selectedRows && selectedRows[0] ? selectedRows[0].custom_id : '',
              },
            });

            if (response && response.status === 200) {
              totalCompleted = totalCompleted + batch.length;
              if (i === 0) {
                handleAllTypesOfMessagesAutomaticClose(`First batch completed. Total ${totalCompleted} items completed out of ${parsedItems.length}.`, 'success');
              } else {
                handleAllTypesOfMessagesAutomaticClose(`Batch ${i + 1} completed. Total ${totalCompleted} items completed out of ${parsedItems.length}.`, 'success');
              }

              if (response.data && response.data.deal_list) {
                localStorage.setItem('_deals', JSON.stringify(response.data.deal_list));
              }
              if (response.data && response.data.deal_not_available) {
                handleAllTypesOfMessages(response.data.message, 'warning');
              }
            } else {
              anyBatchFailed = true;
              handleAllTypesOfMessages(`Batch ${i + 1} of ${batches.length} failed to process. Please check the file and try again.`, 'error');
            }
          }
          if (anyBatchFailed) {
            handleAllTypesOfMessages(
              'Some assets failed to upload. The list of failed assets is available in Google Drive. Please check it.',
              'warning'
            );
          }

          setItems([]);
          handleClose();
        } else {
          setItems([]);
          if (!isValidColumns) {
            handleAllTypesOfMessages(
              `Row ${invalidRowIndex + 1} : Ensure that the file contains only these 4 Columns [ Asset Id, Incorrect Custom Id, Channel Id, and Correct Custom Id] in the specified order and does not include any headers`,
              'warning'
            );
          }
          if (!channelNotMatch) {
            handleAllTypesOfMessages(
              `Ensure the selected channel is the same as the channel present in the .csv file.`,
              'warning'
            );
          }

          handleClose();
        }
      } catch (error) {
        console.error('An error occurred:', error);
        handleAllTypesOfMessages('There is an Error with the file, Please Check the .csv file and Reupload it!', 'error');
      } finally {
        setItems([]);      
        setLoading(false);
      }
    };

    reader.readAsBinaryString(file);
  };

  const handleClose = () => {
    if (!loading) close();
  };

  return (
    <Dialog
      open={open}
      onClose={() => {
        close();
      }}
    >
      <DialogContent>
        <Dialog
          fullWidth={fullWidth}
          maxWidth={maxWidth}
          open={open}
          onClose={handleClose}
        >
          <MoonLoader
            color={color}
            loading={loading}
            cssOverride={override}
            size={40}
            aria-label="Loading Spinner"
            data-testid="loader"
          />
          {selectedRows && selectedRows.length === 1 ? (
            <>
              <DialogTitle sx={{ textAlign: 'center' }}>Upload CSV</DialogTitle>
              <DialogContent sx={{ marginBottom: 2 }}>
                <DialogContentText sx={{ textAlign: 'center', whiteSpace: 'normal', wordWrap: 'break-word', marginBottom: 2 }}>
                  <b>The .CSV file with no headers should contain the following columns in the specified order: 1) Asset Id, 2) Incorrect Custom Id, 3) Channel Id, and 4) Correct Custom Id</b>
                </DialogContentText>

                <Box
                  noValidate
                  component="form"
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    m: 'auto',
                    width: 'fit-content',
                  }}
                >
                  <FormControl sx={{ mt: 2, minWidth: 120 }}>
                    <input type="file" accept=".csv,.xlsx,.xls" onChange={handleFileUpload} />
                  </FormControl>
                </Box>
              </DialogContent>
              <DialogActions>
                <Button onClick={handleClose}>Close</Button>
              </DialogActions>
            </>            
          ) : (
            <>
              <DialogContentText
                sx={{
                  textAlign: 'center',
                  color: 'warning.main',
                  whiteSpace: 'normal',
                  wordWrap: 'break-word',
                  mb: 2,
                }}
              >
                Please select only one row.
              </DialogContentText>

              <DialogActions sx={{ justifyContent: 'center' }}>
                <Button onClick={handleClose} className="dialog-close-button" disabled={loading}>
                  Close
                </Button>
              </DialogActions>
            </>
          )}
          
        </Dialog>
      </DialogContent>
    </Dialog>
  );
};

export default UploadAssetIds;
